function hourly_wage(currency_field, min_hour_salary_selector, max_hour_salary_selector) {
  let $min_hour_salary = $(min_hour_salary_selector);
  let $max_hour_salary = $(max_hour_salary_selector);
  let hourly_wage_options;
  let currency_id = currency_field.options[currency_field.selectedIndex].dataset.value;

  if(currency_id === undefined) {
    hourly_wage_options = "<option>--------</option>";
    $min_hour_salary.html(hourly_wage_options);
    $max_hour_salary.html(hourly_wage_options);
  } else {
    let url = currency_field.dataset.url + currency_id + "/hourly_wages";

    $.ajax({
      url: url
    }).done(function(data) {
      data['entries']['hourly_wages'].forEach(function(hourly_wage){
        hourly_wage_options += `<option value=${hourly_wage["value"]}>${hourly_wage["label"]}</option>`
      });
      $min_hour_salary.html(hourly_wage_options);
      $max_hour_salary.html(hourly_wage_options);
    });
  }
}

function annual_salary(currency_field, min_salary_selector, max_salary_selector) {
  let $min_salary = $(min_salary_selector);
  let $max_salary = $(max_salary_selector);
  let annual_salary_options;
  let currency_id = currency_field.options[currency_field.selectedIndex].dataset.value;

  if(currency_id === undefined) {
    annual_salary_options = "<option>--------</option>";
    $min_salary.html(annual_salary_options);
    $max_salary.html(annual_salary_options);
  } else {
    let url = currency_field.dataset.url + currency_id + "/annual_incomes";

    $.ajax({
      url: url
    }).done(function(data) {
      data['entries']['annual_incomes'].forEach(function(annual_salary){
        annual_salary_options += `<option value=${annual_salary["value"]}>${annual_salary["label"]}</option>`
      });
      $min_salary.html(annual_salary_options);
      $max_salary.html(annual_salary_options);
    });
  }
}

export { hourly_wage, annual_salary }
